import logo from "../../assets/HarmaLogo2.png";
import logo2 from "../../assets/7white.png";
import { useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import logoHarma from "../../assets/4.png";

import Confetti from 'react-confetti';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const PLAN_COLORS = {
  "Plan Básico": "bg-blue-500",
  "Plan Pro": "bg-purple-500",
  "Plan Premium": "bg-yellow-500",
  default: "bg-gray-500",
};

export default function PlanPayment({ isModalOpen, setIsModalOpen }) {
  const { isDarkMode } = useSelector((state) => state.darkMode);
  const { plan } = useSelector((state) => state.plan);
  const [isConfettiActive, setIsConfettiActive] = useState(false);
  const navigate = useNavigate()

  const planNombre = plan?.nombre || "Plan Básico";
  const planPrecio = plan?.precio || "29.99";
  const planBeneficios = plan?.beneficios || [];

  useEffect(() => {
    setIsConfettiActive(true)
    setTimeout(() => {
      setIsConfettiActive(false)
      setIsModalOpen(false)
      navigate("/client")
    },7000)
  },[])

  return (
    <AnimatePresence>
    {isModalOpen && (

    
      <motion.div
          key="modal-background"
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
        >
        {isConfettiActive && <Confetti  recycle={false}  />}
        <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-lg shadow-lg p-6 font-poppina w-[500px] mx-4 border border-gray-100"
          >
        <div className="shadow w-full max-w-[1000px] h-auto bg-white dark:bg-gray-800 p-6 md:p-8 rounded-lg flex flex-col items-center">
          <motion.div
            className="flex justify-center mb-6 md:mb-10"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <img
              className="w-[200px] md:w-[300px] lg:w-[400px]"
              src={isDarkMode ? logo2 : logo}
              alt="Harma Logo"
            />
          </motion.div>
          <motion.h1
            className="text-2xl md:text-3xl lg:text-4xl font-semibold text-gray-800 dark:text-white mb-4 md:mb-6 text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            ¡Compra exitosa!
          </motion.h1>

          <div className="bg-gray-100 dark:bg-gray-700 p-4 md:p-6 rounded-lg w-full max-w-md text-center">
            <div className="flex justify-center items-center mb-4">
              <img
                src={logoHarma}
                alt="Harma"
                className={`w-10 h-10 p-1 rounded-lg ${
                  PLAN_COLORS[planNombre] || PLAN_COLORS.default
                }`}
              />
              <h2 className="text-xl md:text-2xl font-bold text-gray-800 dark:text-white ml-2">
                {planNombre}
              </h2>
            </div>
            <p className="text-gray-600 dark:text-gray-300 text-lg md:text-xl mb-4 md:mb-6">
              Precio: <span className="font-bold">{planPrecio} MXN</span>
            </p>
            <ul className="text-left text-gray-700 dark:text-gray-300 text-base md:text-lg">
              {planBeneficios.map((beneficio, index) => (
                <li key={index} className="mb-2">
                  <span className="mr-2">✔️</span>
                  {beneficio}
                </li>
              ))}
            </ul>
          </div>

          <motion.div
            className="mt-6 md:mt-8 w-full max-w-md text-center"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            <p className="text-gray-600  dark:text-gray-300 text-base md:text-lg leading-relaxed">
              ¡Gracias por unirte a Harma Studio! Ahora tu podcast es parte del{" "}
              <span
                className={`font-bold ${
                  planNombre === "Plan Básico"
                    ? "text-blue-500"
                    : planNombre === "Plan Pro"
                    ? "text-purple-500"
                    : planNombre === "Plan Premium"
                    ? "text-yellow-700"
                    : ""
                }`}
              >
                {planNombre}
              </span>
              . Nos llena de alegría tenerte en nuestra comunidad y estamos emocionados de acompañarte
              en este viaje para llevar tu contenido al siguiente nivel. ¡Bienvenido a la familia Harma!
            </p>
          </motion.div>
        </div>
        </motion.div>
      </motion.div>
    )}
    </AnimatePresence>
  );
}